module.exports = __webpack_public_path__ + "static/media/ordens.4a4562b1.svg";